// // import { HiSparkles } from 'react-icons/hi2';
// // import React, { useCallback, useState } from 'react';
// // import { Link, useLocation, useRouteMatch } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { MdShoppingCart, MdArrowDropDown } from 'react-icons/md';

// // import Logo from '../../assets/cdi.svg';
// // import history from '../../services/history';
// // import { signOut } from '../../store/modules/auth/actions';
// // import { opTipoAcesso } from '../../lib/const';
// // import ActionMenu from '../ActionMenu';

// // import { BIDetectTextJobModal } from '../BI/BIDetectTextJobModal';

// // import { Container, Menu, User, CartMenu } from './styles';
// // import { CART, HELLO, opIdiomaCatalogo } from '../../lib/idiomaAppOptions';

// // const BI_OPTIONS = {
// //   DETECT_TEXT_JOB: 'DETECT_TEXT_JOB',
// //   // OUTRO_BI: 'OUTRO_BI',
// // };

// // function Header() {
// //   const { url } = useRouteMatch();
// //   const location = useLocation();

// //   const [openBIMenu, setOpenBIMenu] = useState(false);
// //   const [selectedBI, setSelectedBI] = useState(null);

// //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
// //   const idiomaCatalogo = useSelector(
// //     (state) => state.param.idiomaCatalogo || null
// //   );

// //   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

// //   const profile = useSelector((state) => {
// //     const { userId, name = '', adm, empresa } = state.user.profile || {};
// //     const { idEmpresa, url: logotipo } = empresa || {};

// //     return { userId, name, adm, idEmpresa, url: logotipo };
// //   });

// //   const { app, signed } = useSelector((state) => state.auth);
// //   const quantidadeItens = useSelector((state) => state.cart.items.length);

// //   const dispatch = useDispatch();

// //   const handleLogout = useCallback(() => {
// //     dispatch(signOut(profile.name));
// //   }, [dispatch, profile]);

// //   const handleUsuarioPerfil = useCallback(() => {
// //     const { userId, adm, idEmpresa } = profile;

// //     switch (Number(adm)) {
// //       case opTipoAcesso.ADMIN_PLATAFORMA:
// //       case opTipoAcesso.ADMIN_EMPRESA:
// //       case opTipoAcesso.USUARIO:
// //         history.push('/empresa/usuario/perfil', {
// //           background: location,
// //           idEmpresa,
// //           id: userId,
// //         });
// //         break;
// //       case opTipoAcesso.CLIENTE:
// //         history.push('/usuario/perfil', {
// //           id: userId,
// //         });
// //         break;
// //       default:
// //         break;
// //     }
// //   }, [location, profile]);

// //   const handleUsuarioSolicitacao = useCallback(() => {
// //     const { userId, adm, idEmpresa } = profile;

// //     switch (Number(adm)) {
// //       case opTipoAcesso.ADMIN_PLATAFORMA:
// //       case opTipoAcesso.ADMIN_EMPRESA:
// //       case opTipoAcesso.USUARIO:
// //         history.push('/empresa/solicitacao', {
// //           idEmpresa,
// //           id: userId,
// //         });
// //         break;
// //       case opTipoAcesso.CLIENTE:
// //         history.push('/usuario/solicitacao', {
// //           id: userId,
// //         });
// //         break;
// //       default:
// //         break;
// //     }
// //   }, [profile]);

// //   const handleCarrinho = useCallback(() => {
// //     history.push('/carrinho');
// //   }, []);

// //   const handleOpenBI = useCallback((biName) => {
// //     setSelectedBI(biName);
// //     setOpenBIMenu(false);
// //   }, []);

// //   const handleCloseBI = useCallback(() => {
// //     setSelectedBI(null);
// //   }, []);

// //   return (
// //     <Container>
// //       <img
// //         src={profile.url ? profile.url : Logo}
// //         alt="CDI - Catálogo Eletrônico"
// //       />

// //       <ul>
// //         {[opTipoAcesso.ADMIN_PLATAFORMA].includes(Number(profile.adm)) && (
// //           <>
// //             <Menu selected={url.startsWith('/catalogo.partes')}>
// //               <Link to="/catalogo.partes">Home</Link>
// //             </Menu>

// //             <Menu
// //               selected={
// //                 url.startsWith('/edicao') ||
// //                 (url.startsWith('/catalogo') && !url.includes('.'))
// //               }
// //             >
// //               <Link to="/catalogo">Catálogos</Link>
// //             </Menu>

// //             <Menu selected={url.startsWith('/fabricante')}>
// //               <Link to="/fabricante">Fabricantes</Link>
// //             </Menu>

// //             <Menu selected={url.startsWith('/modelo')}>
// //               <Link to="/modelo">Modelos</Link>
// //             </Menu>

// //             <Menu selected={url.startsWith('/empresa')}>
// //               <Link to="/empresa">Empresas</Link>
// //             </Menu>

// //             <span>|</span>

// //             <Menu type="button" className="bi-menu-wrapper">
// //               <button
// //                 type="button"
// //                 className="bi-menu-button"
// //                 onClick={() => setOpenBIMenu((state) => !state)}
// //                 title="Business Intelligence"
// //               >
// //                 BI <MdArrowDropDown size={18} />
// //               </button>

// //               {openBIMenu && (
// //                 <div className="bi-menu-dropdown">
// //                   <button
// //                     type="button"
// //                     onClick={() => handleOpenBI(BI_OPTIONS.DETECT_TEXT_JOB)}
// //                   >
// //                     <HiSparkles size={18} /> Automação Mapeamento
// //                   </button>
// //                   {/*
// //                   <button
// //                     type="button"
// //                     onClick={() => handleOpenBI(BI_OPTIONS.OUTRO_BI)}
// //                   >
// //                     Outro BI
// //                   </button>
// //                   */}
// //                 </div>
// //               )}
// //             </Menu>
// //           </>
// //         )}

// //         {!app &&
// //           [opTipoAcesso.ADMIN_EMPRESA, opTipoAcesso.CLIENTE].includes(
// //             Number(profile.adm)
// //           ) && (
// //             <Menu selected={url.startsWith('/catalogo.partes')}>
// //               <Link to="/catalogo.partes">Home</Link>
// //             </Menu>
// //           )}

// //         {!app && [opTipoAcesso.CLIENTE].includes(Number(profile.adm)) && (
// //           <Menu selected={url.startsWith('/usuario')}>
// //             <Link
// //               to={{
// //                 pathname: '/usuario/detalhe',
// //                 state: { id: profile.userId },
// //               }}
// //             >
// //               Minha Conta
// //             </Link>
// //           </Menu>
// //         )}

// //         {!app && [opTipoAcesso.ADMIN_EMPRESA].includes(Number(profile.adm)) && (
// //           <Menu
// //             selected={
// //               url.startsWith('/empresa') ||
// //               url.startsWith('/edicao') ||
// //               (url.startsWith('/catalogo') && !url.includes('.'))
// //             }
// //           >
// //             <Link
// //               to={{
// //                 pathname: '/empresa/detalhe',
// //                 state: { id: profile.idEmpresa },
// //               }}
// //             >
// //               Administrativo
// //             </Link>
// //           </Menu>
// //         )}
// //       </ul>

// //       {selectedBI === BI_OPTIONS.DETECT_TEXT_JOB && (
// //         <BIDetectTextJobModal open onClose={handleCloseBI} />
// //       )}
// //       {/*
// //       {selectedBI === BI_OPTIONS.OUTRO_BI && (
// //         <OutroBIModal open onClose={handleCloseBI} />
// //       )}
// //       */}

// //       <User>
// //         <CartMenu>
// //           {quantidadeItens !== 0 && <span>{quantidadeItens}</span>}
// //           <button type="button" title={CART[idioma]}>
// //             <MdShoppingCart size={22} onClick={handleCarrinho} />
// //           </button>
// //         </CartMenu>

// //         {signed ? (
// //           <>
// //             <h4>
// //               {HELLO[idioma]}, <strong>{profile.name.split(' ', 1)}</strong>
// //             </h4>

// //             {!app && (
// //               <ActionMenu
// //                 Icon={MdArrowDropDown}
// //                 onUserProfile={handleUsuarioPerfil}
// //                 onUserPurchase={handleUsuarioSolicitacao}
// //                 onAppExit={handleLogout}
// //               />
// //             )}
// //           </>
// //         ) : (
// //           <></>
// //         )}
// //       </User>
// //     </Container>
// //   );
// // }

// // export { Header };

// import { HiSparkles } from 'react-icons/hi2';
// import React, { useCallback, useState } from 'react';
// import { Link, useLocation, useRouteMatch } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { MdShoppingCart, MdArrowDropDown, MdLogin } from 'react-icons/md';

// import Logo from '../../assets/cdi.svg';
// import history from '../../services/history';
// import { signOut } from '../../store/modules/auth/actions';
// import { opTipoAcesso } from '../../lib/const';
// import ActionMenu from '../ActionMenu';

// import { BIDetectTextJobModal } from '../BI/BIDetectTextJobModal';
// import { BIAcessosPlataformaModal } from '../BI/BIAcessosPlataformaModal';

// import { Container, Menu, User, CartMenu } from './styles';

// import { CART, HELLO, opIdiomaCatalogo } from '../../lib/idiomaAppOptions';

// const BI_OPTIONS = {
//   DETECT_TEXT_JOB: 'DETECT_TEXT_JOB',
//   ACESSOS_PLATAFORMA: 'ACESSOS_PLATAFORMA',
//   // OUTRO_BI: 'OUTRO_BI',
// };

// function Header() {
//   const { url } = useRouteMatch();
//   const location = useLocation();

//   const [openBIMenu, setOpenBIMenu] = useState(false);
//   const [selectedBI, setSelectedBI] = useState(null);

//   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );

//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   const profile = useSelector((state) => {
//     const { userId, name = '', adm, empresa } = state.user.profile || {};
//     const { idEmpresa, url: logotipo } = empresa || {};

//     return { userId, name, adm, idEmpresa, url: logotipo };
//   });

//   const { app, signed } = useSelector((state) => state.auth);
//   const quantidadeItens = useSelector((state) => state.cart.items.length);

//   const dispatch = useDispatch();

//   const handleLogout = useCallback(() => {
//     dispatch(signOut(profile.name));
//   }, [dispatch, profile]);

//   const handleUsuarioPerfil = useCallback(() => {
//     const { userId, adm, idEmpresa } = profile;

//     switch (Number(adm)) {
//       case opTipoAcesso.ADMIN_PLATAFORMA:
//       case opTipoAcesso.ADMIN_EMPRESA:
//       case opTipoAcesso.USUARIO:
//         history.push('/empresa/usuario/perfil', {
//           background: location,
//           idEmpresa,
//           id: userId,
//         });
//         break;
//       case opTipoAcesso.CLIENTE:
//         history.push('/usuario/perfil', {
//           id: userId,
//         });
//         break;
//       default:
//         break;
//     }
//   }, [location, profile]);

//   const handleUsuarioSolicitacao = useCallback(() => {
//     const { userId, adm, idEmpresa } = profile;

//     switch (Number(adm)) {
//       case opTipoAcesso.ADMIN_PLATAFORMA:
//       case opTipoAcesso.ADMIN_EMPRESA:
//       case opTipoAcesso.USUARIO:
//         history.push('/empresa/solicitacao', {
//           idEmpresa,
//           id: userId,
//         });
//         break;
//       case opTipoAcesso.CLIENTE:
//         history.push('/usuario/solicitacao', {
//           id: userId,
//         });
//         break;
//       default:
//         break;
//     }
//   }, [profile]);

//   const handleCarrinho = useCallback(() => {
//     history.push('/carrinho');
//   }, []);

//   const handleOpenBI = useCallback((biName) => {
//     setSelectedBI(biName);
//     setOpenBIMenu(false);
//   }, []);

//   const handleCloseBI = useCallback(() => {
//     setSelectedBI(null);
//   }, []);

//   return (
//     <Container>
//       <img
//         src={profile.url ? profile.url : Logo}
//         alt="CDI - Catálogo Eletrônico"
//       />

//       <ul>
//         {[opTipoAcesso.ADMIN_PLATAFORMA].includes(Number(profile.adm)) && (
//           <>
//             <Menu selected={url.startsWith('/catalogo.partes')}>
//               <Link to="/catalogo.partes">Home</Link>
//             </Menu>

//             <Menu
//               selected={
//                 url.startsWith('/edicao') ||
//                 (url.startsWith('/catalogo') && !url.includes('.'))
//               }
//             >
//               <Link to="/catalogo">Catálogos</Link>
//             </Menu>

//             <Menu selected={url.startsWith('/fabricante')}>
//               <Link to="/fabricante">Fabricantes</Link>
//             </Menu>

//             <Menu selected={url.startsWith('/modelo')}>
//               <Link to="/modelo">Modelos</Link>
//             </Menu>

//             <Menu selected={url.startsWith('/empresa')}>
//               <Link to="/empresa">Empresas</Link>
//             </Menu>

//             <span>|</span>

//             <Menu type="button" className="bi-menu-wrapper">
//               <button
//                 type="button"
//                 className="bi-menu-button"
//                 onClick={() => setOpenBIMenu((state) => !state)}
//                 title="Business Intelligence"
//               >
//                 BI <MdArrowDropDown size={18} />
//               </button>

//               {openBIMenu && (
//                 <div className="bi-menu-dropdown">
//                   <button
//                     type="button"
//                     onClick={() => handleOpenBI(BI_OPTIONS.DETECT_TEXT_JOB)}
//                   >
//                     <HiSparkles size={18} /> Automação Mapeamento
//                   </button>
//                   <button
//                     type="button"
//                     onClick={() => handleOpenBI(BI_OPTIONS.ACESSOS_PLATAFORMA)}
//                   >
//                     <MdLogin HiSparkles size={18} /> Acessos Plataforma
//                   </button>
//                   {/*
//                   <button
//                     type="button"
//                     onClick={() => handleOpenBI(BI_OPTIONS.OUTRO_BI)}
//                   >
//                     Outro BI
//                   </button>
//                   */}
//                 </div>
//               )}
//             </Menu>
//           </>
//         )}

//         {!app &&
//           [opTipoAcesso.ADMIN_EMPRESA, opTipoAcesso.CLIENTE].includes(
//             Number(profile.adm)
//           ) && (
//             <Menu selected={url.startsWith('/catalogo.partes')}>
//               <Link to="/catalogo.partes">Home</Link>
//             </Menu>
//           )}

//         {!app && [opTipoAcesso.CLIENTE].includes(Number(profile.adm)) && (
//           <Menu selected={url.startsWith('/usuario')}>
//             <Link
//               to={{
//                 pathname: '/usuario/detalhe',
//                 state: { id: profile.userId },
//               }}
//             >
//               Minha Conta
//             </Link>
//           </Menu>
//         )}

//         {!app && [opTipoAcesso.ADMIN_EMPRESA].includes(Number(profile.adm)) && (
//           <Menu
//             selected={
//               url.startsWith('/empresa') ||
//               url.startsWith('/edicao') ||
//               (url.startsWith('/catalogo') && !url.includes('.'))
//             }
//           >
//             <Link
//               to={{
//                 pathname: '/empresa/detalhe',
//                 state: { id: profile.idEmpresa },
//               }}
//             >
//               Administrativo
//             </Link>
//           </Menu>
//         )}
//       </ul>

//       {selectedBI === BI_OPTIONS.DETECT_TEXT_JOB && (
//         <BIDetectTextJobModal open onClose={handleCloseBI} />
//       )}
//       {selectedBI === BI_OPTIONS.ACESSOS_PLATAFORMA && (
//         <BIAcessosPlataformaModal open onClose={handleCloseBI} />
//       )}
//       {/*
//       {selectedBI === BI_OPTIONS.OUTRO_BI && (
//         <OutroBIModal open onClose={handleCloseBI} />
//       )}
//       */}

//       <User>
//         <CartMenu>
//           {quantidadeItens !== 0 && <span>{quantidadeItens}</span>}
//           <button type="button" title={CART[idioma]}>
//             <MdShoppingCart size={22} onClick={handleCarrinho} />
//           </button>
//         </CartMenu>

//         {signed ? (
//           <>
//             <h4>
//               {HELLO[idioma]}, <strong>{profile.name.split(' ', 1)}</strong>
//             </h4>

//             {!app && (
//               <ActionMenu
//                 Icon={MdArrowDropDown}
//                 onUserProfile={handleUsuarioPerfil}
//                 onUserPurchase={handleUsuarioSolicitacao}
//                 onAppExit={handleLogout}
//               />
//             )}
//           </>
//         ) : (
//           <></>
//         )}
//       </User>
//     </Container>
//   );
// }

// export { Header };

// import { HiSparkles } from 'react-icons/hi2';
// import React, { useCallback, useState } from 'react';
// import { Link, useLocation, useRouteMatch } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { MdShoppingCart, MdArrowDropDown } from 'react-icons/md';

// import Logo from '../../assets/cdi.svg';
// import history from '../../services/history';
// import { signOut } from '../../store/modules/auth/actions';
// import { opTipoAcesso } from '../../lib/const';
// import ActionMenu from '../ActionMenu';

// import { BIDetectTextJobModal } from '../BI/BIDetectTextJobModal';

// import { Container, Menu, User, CartMenu } from './styles';
// import { CART, HELLO, opIdiomaCatalogo } from '../../lib/idiomaAppOptions';

// const BI_OPTIONS = {
//   DETECT_TEXT_JOB: 'DETECT_TEXT_JOB',
//   // OUTRO_BI: 'OUTRO_BI',
// };

// function Header() {
//   const { url } = useRouteMatch();
//   const location = useLocation();

//   const [openBIMenu, setOpenBIMenu] = useState(false);
//   const [selectedBI, setSelectedBI] = useState(null);

//   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );

//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   const profile = useSelector((state) => {
//     const { userId, name = '', adm, empresa } = state.user.profile || {};
//     const { idEmpresa, url: logotipo } = empresa || {};

//     return { userId, name, adm, idEmpresa, url: logotipo };
//   });

//   const { app, signed } = useSelector((state) => state.auth);
//   const quantidadeItens = useSelector((state) => state.cart.items.length);

//   const dispatch = useDispatch();

//   const handleLogout = useCallback(() => {
//     dispatch(signOut(profile.name));
//   }, [dispatch, profile]);

//   const handleUsuarioPerfil = useCallback(() => {
//     const { userId, adm, idEmpresa } = profile;

//     switch (Number(adm)) {
//       case opTipoAcesso.ADMIN_PLATAFORMA:
//       case opTipoAcesso.ADMIN_EMPRESA:
//       case opTipoAcesso.USUARIO:
//         history.push('/empresa/usuario/perfil', {
//           background: location,
//           idEmpresa,
//           id: userId,
//         });
//         break;
//       case opTipoAcesso.CLIENTE:
//         history.push('/usuario/perfil', {
//           id: userId,
//         });
//         break;
//       default:
//         break;
//     }
//   }, [location, profile]);

//   const handleUsuarioSolicitacao = useCallback(() => {
//     const { userId, adm, idEmpresa } = profile;

//     switch (Number(adm)) {
//       case opTipoAcesso.ADMIN_PLATAFORMA:
//       case opTipoAcesso.ADMIN_EMPRESA:
//       case opTipoAcesso.USUARIO:
//         history.push('/empresa/solicitacao', {
//           idEmpresa,
//           id: userId,
//         });
//         break;
//       case opTipoAcesso.CLIENTE:
//         history.push('/usuario/solicitacao', {
//           id: userId,
//         });
//         break;
//       default:
//         break;
//     }
//   }, [profile]);

//   const handleCarrinho = useCallback(() => {
//     history.push('/carrinho');
//   }, []);

//   const handleOpenBI = useCallback((biName) => {
//     setSelectedBI(biName);
//     setOpenBIMenu(false);
//   }, []);

//   const handleCloseBI = useCallback(() => {
//     setSelectedBI(null);
//   }, []);

//   return (
//     <Container>
//       <img
//         src={profile.url ? profile.url : Logo}
//         alt="CDI - Catálogo Eletrônico"
//       />

//       <ul>
//         {[opTipoAcesso.ADMIN_PLATAFORMA].includes(Number(profile.adm)) && (
//           <>
//             <Menu selected={url.startsWith('/catalogo.partes')}>
//               <Link to="/catalogo.partes">Home</Link>
//             </Menu>

//             <Menu
//               selected={
//                 url.startsWith('/edicao') ||
//                 (url.startsWith('/catalogo') && !url.includes('.'))
//               }
//             >
//               <Link to="/catalogo">Catálogos</Link>
//             </Menu>

//             <Menu selected={url.startsWith('/fabricante')}>
//               <Link to="/fabricante">Fabricantes</Link>
//             </Menu>

//             <Menu selected={url.startsWith('/modelo')}>
//               <Link to="/modelo">Modelos</Link>
//             </Menu>

//             <Menu selected={url.startsWith('/empresa')}>
//               <Link to="/empresa">Empresas</Link>
//             </Menu>

//             <span>|</span>

//             <Menu type="button" className="bi-menu-wrapper">
//               <button
//                 type="button"
//                 className="bi-menu-button"
//                 onClick={() => setOpenBIMenu((state) => !state)}
//                 title="Business Intelligence"
//               >
//                 BI <MdArrowDropDown size={18} />
//               </button>

//               {openBIMenu && (
//                 <div className="bi-menu-dropdown">
//                   <button
//                     type="button"
//                     onClick={() => handleOpenBI(BI_OPTIONS.DETECT_TEXT_JOB)}
//                   >
//                     <HiSparkles size={18} /> Automação Mapeamento
//                   </button>
//                   {/*
//                   <button
//                     type="button"
//                     onClick={() => handleOpenBI(BI_OPTIONS.OUTRO_BI)}
//                   >
//                     Outro BI
//                   </button>
//                   */}
//                 </div>
//               )}
//             </Menu>
//           </>
//         )}

//         {!app &&
//           [opTipoAcesso.ADMIN_EMPRESA, opTipoAcesso.CLIENTE].includes(
//             Number(profile.adm)
//           ) && (
//             <Menu selected={url.startsWith('/catalogo.partes')}>
//               <Link to="/catalogo.partes">Home</Link>
//             </Menu>
//           )}

//         {!app && [opTipoAcesso.CLIENTE].includes(Number(profile.adm)) && (
//           <Menu selected={url.startsWith('/usuario')}>
//             <Link
//               to={{
//                 pathname: '/usuario/detalhe',
//                 state: { id: profile.userId },
//               }}
//             >
//               Minha Conta
//             </Link>
//           </Menu>
//         )}

//         {!app && [opTipoAcesso.ADMIN_EMPRESA].includes(Number(profile.adm)) && (
//           <Menu
//             selected={
//               url.startsWith('/empresa') ||
//               url.startsWith('/edicao') ||
//               (url.startsWith('/catalogo') && !url.includes('.'))
//             }
//           >
//             <Link
//               to={{
//                 pathname: '/empresa/detalhe',
//                 state: { id: profile.idEmpresa },
//               }}
//             >
//               Administrativo
//             </Link>
//           </Menu>
//         )}
//       </ul>

//       {selectedBI === BI_OPTIONS.DETECT_TEXT_JOB && (
//         <BIDetectTextJobModal open onClose={handleCloseBI} />
//       )}
//       {/*
//       {selectedBI === BI_OPTIONS.OUTRO_BI && (
//         <OutroBIModal open onClose={handleCloseBI} />
//       )}
//       */}

//       <User>
//         <CartMenu>
//           {quantidadeItens !== 0 && <span>{quantidadeItens}</span>}
//           <button type="button" title={CART[idioma]}>
//             <MdShoppingCart size={22} onClick={handleCarrinho} />
//           </button>
//         </CartMenu>

//         {signed ? (
//           <>
//             <h4>
//               {HELLO[idioma]}, <strong>{profile.name.split(' ', 1)}</strong>
//             </h4>

//             {!app && (
//               <ActionMenu
//                 Icon={MdArrowDropDown}
//                 onUserProfile={handleUsuarioPerfil}
//                 onUserPurchase={handleUsuarioSolicitacao}
//                 onAppExit={handleLogout}
//               />
//             )}
//           </>
//         ) : (
//           <></>
//         )}
//       </User>
//     </Container>
//   );
// }

// export { Header };

import { HiSparkles } from 'react-icons/hi2';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  MdShoppingCart,
  MdArrowDropDown,
  MdLogin,
  MdLightbulb,
} from 'react-icons/md';

import Logo from '../../assets/cdi.svg';
import api from '../../services/api';
import history from '../../services/history';
import { signOut } from '../../store/modules/auth/actions';
import { opTipoAcesso } from '../../lib/const';
import ActionMenu from '../ActionMenu';

import { BIDetectTextJobModal } from '../BI/BIDetectTextJobModal';
import { BIAcessosPlataformaModal } from '../BI/BIAcessosPlataformaModal';

import { Container, Menu, User, CartMenu } from './styles';

import { CART, HELLO, opIdiomaCatalogo } from '../../lib/idiomaAppOptions';

const BI_OPTIONS = {
  DETECT_TEXT_JOB: 'DETECT_TEXT_JOB',
  ACESSOS_PLATAFORMA: 'ACESSOS_PLATAFORMA',
  // OUTRO_BI: 'OUTRO_BI',
};

function Header() {
  const { url } = useRouteMatch();
  const location = useLocation();

  const [openBIMenu, setOpenBIMenu] = useState(false);
  const [selectedBI, setSelectedBI] = useState(null);

  /** idioma do catálogo escolhido pelo usuário (null = padrão) */
  const idiomaCatalogo = useSelector(
    (state) => state.param.idiomaCatalogo || null
  );

  const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

  const profile = useSelector((state) => {
    const { userId, name = '', adm, empresa } = state.user.profile || {};
    const { idEmpresa, url: logotipo } = empresa || {};

    return { userId, name, adm, idEmpresa, url: logotipo };
  });

  const { app, signed } = useSelector((state) => state.auth);
  const quantidadeItens = useSelector((state) => state.cart.items.length);

  /** quantidade de sugestões pendentes (badge exclusivo do admin de
   * plataforma; ícone só renderiza se houver pendência) */
  const [sugestoesPendentes, setSugestoesPendentes] = useState(0);

  const isAdminPlataforma =
    Number(profile.adm) === opTipoAcesso.ADMIN_PLATAFORMA;

  useEffect(() => {
    if (!signed || !isAdminPlataforma) {
      setSugestoesPendentes(0);
      return;
    }

    /** status 0 = Pendente; "registros" é o total de registros retornado
     * pelo backend (não confundir com "total", que é o nº de páginas) */
    api
      .get('/sugestao/0/1')
      .then((response) => {
        setSugestoesPendentes(Number(response.data.registros) || 0);
      })
      .catch(() => {
        setSugestoesPendentes(0);
      });
  }, [signed, isAdminPlataforma, location]);

  const handleSugestoesPendentes = useCallback(() => {
    history.push('/sugestao');
  }, []);

  const dispatch = useDispatch();

  const handleLogout = useCallback(() => {
    dispatch(signOut(profile.name));
  }, [dispatch, profile]);

  const handleUsuarioPerfil = useCallback(() => {
    const { userId, adm, idEmpresa } = profile;

    switch (Number(adm)) {
      case opTipoAcesso.ADMIN_PLATAFORMA:
      case opTipoAcesso.ADMIN_EMPRESA:
      case opTipoAcesso.USUARIO:
        history.push('/empresa/usuario/perfil', {
          background: location,
          idEmpresa,
          id: userId,
        });
        break;
      case opTipoAcesso.CLIENTE:
        history.push('/usuario/perfil', {
          id: userId,
        });
        break;
      default:
        break;
    }
  }, [location, profile]);

  const handleUsuarioSolicitacao = useCallback(() => {
    const { userId, adm, idEmpresa } = profile;

    switch (Number(adm)) {
      case opTipoAcesso.ADMIN_PLATAFORMA:
      case opTipoAcesso.ADMIN_EMPRESA:
      case opTipoAcesso.USUARIO:
        history.push('/empresa/solicitacao', {
          idEmpresa,
          id: userId,
        });
        break;
      case opTipoAcesso.CLIENTE:
        history.push('/usuario/solicitacao', {
          id: userId,
        });
        break;
      default:
        break;
    }
  }, [profile]);

  const handleCarrinho = useCallback(() => {
    history.push('/carrinho');
  }, []);

  const handleOpenBI = useCallback((biName) => {
    setSelectedBI(biName);
    setOpenBIMenu(false);
  }, []);

  const handleCloseBI = useCallback(() => {
    setSelectedBI(null);
  }, []);

  return (
    <Container>
      <img
        src={profile.url ? profile.url : Logo}
        alt="CDI - Catálogo Eletrônico"
      />

      <ul>
        {[opTipoAcesso.ADMIN_PLATAFORMA].includes(Number(profile.adm)) && (
          <>
            <Menu selected={url.startsWith('/catalogo.partes')}>
              <Link to="/catalogo.partes">Home</Link>
            </Menu>

            <Menu
              selected={
                url.startsWith('/edicao') ||
                (url.startsWith('/catalogo') && !url.includes('.'))
              }
            >
              <Link to="/catalogo">Catálogos</Link>
            </Menu>

            <Menu selected={url.startsWith('/fabricante')}>
              <Link to="/fabricante">Fabricantes</Link>
            </Menu>

            <Menu selected={url.startsWith('/modelo')}>
              <Link to="/modelo">Modelos</Link>
            </Menu>

            <Menu selected={url.startsWith('/empresa')}>
              <Link to="/empresa">Empresas</Link>
            </Menu>

            <span>|</span>

            <Menu type="button" className="bi-menu-wrapper">
              <button
                type="button"
                className="bi-menu-button"
                onClick={() => setOpenBIMenu((state) => !state)}
                title="Business Intelligence"
              >
                BI <MdArrowDropDown size={18} />
              </button>

              {openBIMenu && (
                <div className="bi-menu-dropdown">
                  <button
                    type="button"
                    onClick={() => handleOpenBI(BI_OPTIONS.DETECT_TEXT_JOB)}
                  >
                    <HiSparkles size={18} /> Automação Mapeamento
                  </button>
                  <button
                    type="button"
                    onClick={() => handleOpenBI(BI_OPTIONS.ACESSOS_PLATAFORMA)}
                  >
                    <MdLogin HiSparkles size={18} /> Acessos Plataforma
                  </button>
                  {/*
                  <button
                    type="button"
                    onClick={() => handleOpenBI(BI_OPTIONS.OUTRO_BI)}
                  >
                    Outro BI
                  </button>
                  */}
                </div>
              )}
            </Menu>
          </>
        )}

        {!app &&
          [opTipoAcesso.ADMIN_EMPRESA, opTipoAcesso.CLIENTE].includes(
            Number(profile.adm)
          ) && (
            <Menu selected={url.startsWith('/catalogo.partes')}>
              <Link to="/catalogo.partes">Home</Link>
            </Menu>
          )}

        {!app && [opTipoAcesso.CLIENTE].includes(Number(profile.adm)) && (
          <Menu selected={url.startsWith('/usuario')}>
            <Link
              to={{
                pathname: '/usuario/detalhe',
                state: { id: profile.userId },
              }}
            >
              Minha Conta
            </Link>
          </Menu>
        )}

        {!app && [opTipoAcesso.ADMIN_EMPRESA].includes(Number(profile.adm)) && (
          <Menu
            selected={
              url.startsWith('/empresa') ||
              url.startsWith('/edicao') ||
              (url.startsWith('/catalogo') && !url.includes('.'))
            }
          >
            <Link
              to={{
                pathname: '/empresa/detalhe',
                state: { id: profile.idEmpresa },
              }}
            >
              Administrativo
            </Link>
          </Menu>
        )}
      </ul>

      {selectedBI === BI_OPTIONS.DETECT_TEXT_JOB && (
        <BIDetectTextJobModal open onClose={handleCloseBI} />
      )}
      {selectedBI === BI_OPTIONS.ACESSOS_PLATAFORMA && (
        <BIAcessosPlataformaModal open onClose={handleCloseBI} />
      )}
      {/*
      {selectedBI === BI_OPTIONS.OUTRO_BI && (
        <OutroBIModal open onClose={handleCloseBI} />
      )}
      */}

      <User>
        {isAdminPlataforma && sugestoesPendentes > 0 && (
          <CartMenu>
            <span>{sugestoesPendentes}</span>
            <button
              type="button"
              title="Sugestões pendentes"
              onClick={handleSugestoesPendentes}
            >
              <MdLightbulb size={22} />
            </button>
          </CartMenu>
        )}

        <CartMenu>
          {quantidadeItens !== 0 && <span>{quantidadeItens}</span>}
          <button type="button" title={CART[idioma]}>
            <MdShoppingCart size={22} onClick={handleCarrinho} />
          </button>
        </CartMenu>

        {signed ? (
          <>
            <h4>
              {HELLO[idioma]}, <strong>{profile.name.split(' ', 1)}</strong>
            </h4>

            {!app && (
              <ActionMenu
                Icon={MdArrowDropDown}
                onUserProfile={handleUsuarioPerfil}
                onUserPurchase={handleUsuarioSolicitacao}
                onAppExit={handleLogout}
              />
            )}
          </>
        ) : (
          <></>
        )}
      </User>
    </Container>
  );
}

export { Header };
